import { featureFlagIsEnabled } from '@weavix/domain/src/feature-flag/flag-is-enabled';
import { FeatureId } from '@weavix/models/src/features/feature';
import { facilitiesContext } from 'models-mobx/facilities-store/facilities-store';
import { FeatureFlag, featureFlagsContext } from './feature-flags-store';
import { featuresContext } from './features-store';

/** Whether [featureId] is on for the logged-in user, read synchronously; off until the feature and its flags load. */
export function isFeatureEnabled(featureId: FeatureId): boolean {
    const feature = featuresContext.get()?.get(featureId);
    if (!feature) return false;
    const facilityIds = (facilitiesContext.get()?.getAll() ?? []).map(x => x.id);
    const flags = featureFlagsContext.get()?.getAll((x: FeatureFlag) => x.featureId === featureId && x.enabled !== undefined) ?? [];
    return featureFlagIsEnabled(featureId, feature, flags, facilityIds, false).enabled;
}
